import { gql } from '@apollo/client';

const STUDY_LOGS_QUERY = gql`
  query studyLogs($studyId: ID!) {
    studyLogs(studyId: $studyId) {
      description
      subDescriptions
      performer {
        type
        actionBy {
          firstName
          lastName
        }
      }
      triggerAt
    }
  }
`;

export default STUDY_LOGS_QUERY;
